<template>
    <base-spinner v-if="isLoading"></base-spinner>

    <div v-if="error" class="notification is-danger is-light">
        <p>{{ error }}</p>
    </div>

    <div v-if="currentUser && !isLoading">
        <div v-if="currentUser.role == 'admin'">
            <AdminLanding></AdminLanding>
        </div>

        <div v-else>
            <VolunteerLanding></VolunteerLanding>
        </div>
    </div>
</template>

<script>
import AdminLanding from "../components/landing/AdminLanding.vue"
import VolunteerLanding from "../components/landing/VolunteerLanding.vue";

export default {
    data() {
        return {
            isLoading: false,
            error: null
        }
    },
    created() {
        this.loadUserProfile();
        this.loadFeatureConfiguration();
    },
    components: {
        AdminLanding,
        VolunteerLanding
    },
    methods: {
        async loadUserProfile() {
            this.isLoading = true;
            try {
                await this.$store.dispatch('user/loadUserProfile');
            } catch (error) {
                this.error = error.message;
            }
            this.isLoading = false;
        },
        async loadFeatureConfiguration() {
            try {
                await this.$store.dispatch('configurations/loadFeatureConfigurations');
            } catch (error) {
                this.error = error.message;
            }
        }
    },
    computed: {
        currentUser() {
            return this.$store.getters['user/getCurrentUser'];
        }
    }
}
</script>